<template>
    <div>
        <div class="desktop:text-left
                    flex
                    flex-col
                    pt-7 desktop:pt-3
                    pb-2"
            :class="theme !== 'themeAlt' ? 'justify-center px-5 text-center' : 'text-left text-navy-dark font-bold'">
                <span v-if="theme !== 'themeAlt'">
                    <div class=""
                        :class="theme !== 'themeAlt' ? 'text-white italic font-light text-md' : ' text-navy-dark text-lg font-bold pr-2'">
                        <span v-if="theme !== 'themeAlt'">QUESTION</span> {{ currentQuestion + 1 }} of {{ quiz.length }}:
                    </div>
                    <h2 class=""
                        :class="theme !== 'themeAlt' ? 'text-white text-lg desktop:text-xl' : 'text-navy-dark text-lg desktop:text-lg'">
                        {{ quiz[currentQuestion].heading || '' }}
                    </h2>
                </span>
                <span v-else>
                    <div class=""
                        :class="theme !== 'themeAlt' ? 'text-white italic font-light text-md' : ' text-navy-dark text-lg font-bold pr-2'">
                        <span v-if="theme !== 'themeAlt'">QUESTION</span> {{ currentQuestion + 1 }} of {{ quiz.length }}:
                        <h2 class="inline"
                            :class="theme !== 'themeAlt' ? 'text-white text-lg desktop:text-xl' : 'text-navy-dark text-lg desktop:text-lg'">
                            {{ quiz[currentQuestion].heading || '' }}
                        </h2>
                    </div>

                </span>
        </div>

        <div class="m-auto desktop:m-0
                    max-w-xl"
                    :class="theme !== 'themeAlt' ? 'px-5 py-4' : ''">
            <QuizItems :items="quiz[currentQuestion].answers"
                       :answer-question="answerQuestion"
                       :selected-answer="selectedAnswer"
                       :heading="quiz[currentQuestion].heading"
                       :theme="theme"/>
            <div class="flex
                        justify-center desktop:justify-end
                        pt-5">
                <div class="px-6
                            hidden md:block">
                    <a v-if="currentQuestion > 0"
                       class="btn-secondary
                              cursor-pointer"
                       id="quiz-back"
                       @click="previousQuestion()">
                        Back
                    </a>
                </div>
                <div class="flex
                            items-center">
                    <div class="flex
                                justify-center">
                        <a class="cursor-pointer"
                           id="quiz-skip"
                           :class="theme === 'themeSalmon' || 'themeAlt' ? 'btn-secondary hover:shadow-sm' : 'btn-primary'"
                           @click="skipQuestion()">
                            Skip
                        </a>
                    </div>
                    <div class="pl-2">
                        <button class="cursor-pointer"
                           id="quiz-submit"
                            :disabled="disabledButton"
                           :class="theme === 'themeSalmon' || 'themeAlt' ? 'btn-primary' : 'btn-secondary hover:shadow-sm'"
                           @click="nextQuestion()">
                            {{ buttonText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QuizItems from './QuizItems.vue'
    import {mapGetters} from "vuex";
    export default {
        name: 'Quiz',
        components: { QuizItems },
        props: {
            quiz: {
                type: Array,
                default: [],
            },
            theme: {
                type: String,
                default: '',
            },
        },
        data () {
            return {
                currentQuestion: 0,
                selectedAnswer: null,
                quizResults: [],
                disabledButton: true,
                quizPreFinish: false,
            }
        },
        computed: {
            ...mapGetters([
                'showOfferCards',
            ]),
            buttonText () {
                return this.currentQuestion === this.quiz.length - 1 ? 'See Results' : 'Next'
            },
        },
        watch: {
            showOfferCards(newVal) {
                if (newVal && this.quizPreFinish) {
                    this.$emit('finish-quiz', this.quizResults)
                }
            }
        },
        methods: {
            answerQuestion (answer) {
                this.selectedAnswer = answer
                this.quizResults[this.currentQuestion] = answer
                this.disabledButton = false
            },
            skipQuestion () {
                this.answerQuestion(this.quiz[this.currentQuestion].skipAnswer)
                this.nextQuestion()
            },
            previousQuestion () {
                if (this.currentQuestion - 1 >= 0) {
                    this.currentQuestion--
                }
            },
            nextQuestion () {
                this.disabledButton = true
                this.selectedAnswer = null
                if (this.currentQuestion + 2 > this.quiz.length) {
                    if(this.quiz[this.currentQuestion].gaEvents) {
                        const gaEvents = this.quiz[this.currentQuestion].gaEvents
                        this.sendEvent(gaEvents.category, gaEvents.action, gaEvents.label)
                    }
                    this.finishQuiz()
                } else {
                    this.currentQuestion++
                }
            },
            finishQuiz () {
                if (this.showOfferCards) {
                    this.$emit('finish-quiz', this.quizResults)
                } else {
                    this.quizPreFinish = true
                    this.$store.dispatch('toggleCheckAvailabilityModal', {
                        visible: true,
                        routeToBuyflow: false,
                        resetSelectedOffer: true,
                        currentCustomerCheck: false,
                    })
                }

            },
        },
    }
</script>
